import { useTranslation } from 'react-i18next'

import { Button, Modal, Radio, Text } from '@mercai/clever'

import { ModalOrderCustomsCostWarningProps } from './modal-order-customs-cost-warning.type'

import { formatCurrency } from '@/helpers'
import { useState } from 'react'
import styles from './modal-order-customs-cost-warning.module.css'

export const ModalOrderCustomsCostWarning = ({
  isOpen,
  onClose,
  onSave,
  actualValue,
  newValue,
}: ModalOrderCustomsCostWarningProps) => {
  const { t } = useTranslation('componentCardsOrderCenterShow')

  const [value, setValue] = useState(actualValue)

  const handleOnSave = () => {
    onSave(value === newValue)
  }

  return (
    <Modal.Root
      isOpen={isOpen}
      onHandleOpen={onClose}
      size="small"
      mainClassName={styles['modal-body']}
    >
      <Modal.Header
        title={
          <Text variant="text-large-bold" className={styles.title}>
            {t('modalOrderCustomsCostWarningTitle')}
          </Text>
        }
        className={styles.header}
      />
      <Modal.Body className={styles.body}>
        <div className={styles.component}>
          <div className={styles.description}>
            <Text>{t('modalOrderCustomsCostWarningDescription')}</Text>
            <Text>{t('modalOrderCustomsCostWarningQuestion')}</Text>
          </div>
          <div>
            <div className={styles.radio}>
              <Radio
                value={value === actualValue}
                onChange={() => setValue(actualValue)}
              />
              <div className={styles['radio-label']}>
                <div>
                  <Text variant="title-base">
                    {t('modalOrderCustomsCostWarningQuestionNo')}
                  </Text>
                </div>
                <div>
                  <Text className={styles.costValue}>
                    {t('modalOrderCustomsCostWarningCustomCostLabel')}{' '}
                    {formatCurrency(actualValue || '0', 'es-MX', 'USD')}
                  </Text>
                </div>
              </div>
            </div>
            <div className={styles.radio}>
              <Radio
                value={value === newValue}
                onChange={() => setValue(newValue)}
              />
              <div className={styles['radio-label']}>
                <div>
                  <Text variant="title-base">
                    {t('modalOrderCustomsCostWarningQuestionYes')}
                  </Text>
                </div>
                <div>
                  <Text className={styles.costValue}>
                    {t('modalOrderCustomsCostWarningCustomCostLabel')}{' '}
                    {formatCurrency(newValue || '0', 'es-MX', 'USD')}
                  </Text>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.footer}>
            <Button variant="primary" onClick={handleOnSave}>
              {t('modalOrderCustomsCostWarningButton')}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal.Root>
  )
}
